// Opening times

export default function openingTimes () {
	var $el = $('.js-opening-times');
	var id  = $el.attr('data-post');
	var time_travel_date = null;
	var time_travel_time = null;

	if ($('.admin-time-travel').length) {
		time_travel_date = $('#admin-time-travel_field--date').val() || null;
		time_travel_time = time_travel_date ? $('#admin-time-travel_field--time').val() : null;
	}

	function refresh () {
		$.ajax({
			url: '/wp/wp-admin/admin-ajax.php',
			type: 'post',
			data: {
				action: 'opening_times_ajax',
				post_id: id,
				"time-travel-date": time_travel_date,
				"time-travel-time": time_travel_time
			},
			success: function (html) {
				$el.html(html);
				$el.closest('.hero__opening-times')
				.hide()
				.fadeIn();
			},
			error: function() {
			// What do?
		}
	});
	}

	if($el.length){
		refresh();
		setTimeout(refresh, 300000);
	}
}
